var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-4",attrs:{"outlined":""}},[_vm._v(" Manual Tests ")])
}
var staticRenderFns = []

export { render, staticRenderFns }